import { render, staticRenderFns } from "./InterfaceSettingsFonts.vue?vue&type=template&id=42dce0ae&scoped=true"
import script from "./InterfaceSettingsFonts.vue?vue&type=script&lang=js"
export * from "./InterfaceSettingsFonts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42dce0ae",
  null
  
)

export default component.exports